export const getRandomKey = () => Math.random().toString(36).substring(2, 15);

export const getRandomArray = (size: number): string[] =>
  Array.from(new Array(size), () => getRandomKey());
